module.exports = __webpack_public_path__ + "static/media/IC_Website.c572e4a7.mp4";